<template>
  <div>
    <div class="comm_popup_wrap_xlarge">
      <div class="comm_title_wrap">
        <h4>{{ $t('MSG_TIT_RUL_DEFAULT_INFO') }}</h4>
      </div>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_NODE_RLT')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <div class="comm_label">
              {{ frame0.relationNodeTypeName }}
            </div>
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_RUL_GIVE_WAY')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-radio
              v-model="ruleInsertType"
              value="new"
            >
              {{ $t('MSG_BTN_NEW') }}
            </sui-radio>
            <sui-radio
              v-model="ruleInsertType"
              value="exist"
            >
              {{ $t('MSG_BTN_EXIST') }}
            </sui-radio>
            <sui-radio
              v-model="ruleInsertType"
              value="none"
            >
              {{ $t('MSG_TXT_NONE') }}
            </sui-radio>
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_RUL_LOAD')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <div class="comm_label">
              {{ ruleName }}
            </div>
            <sui-button
              type="button"
              class="comm_btn_InputScr"
              @click="onClickRule"
            />
          </div>
        </div>
      </div>
      <div class="mrB30" />
      <!-- 기존 -->
      <div
        v-if="!ruleEditable"
        class="comm_view_wrap"
      >
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_WKFL_ID')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <div class="comm_label">
              {{ workflowId }}
            </div>
          </div>
          <div
            class="col-xs-1"
          >
            <sui-input-label
              :label="$t('MSG_TXT_MDLE')"
              :vertical="false"
            />
          </div>
          <div
            class="col-xs-3"
          >
            <div class="comm_label">
              {{ frame0.moduleName }}
            </div>
          </div>
          <div
            class="col-xs-1"
          >
            <sui-input-label
              :label="$t('MSG_TXT_SMDLE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <div class="comm_label">
              {{ frame0.subModuleName }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_RUL_NM')"
              :vertical="false"
              required
            />
          </div>
          <div class="col-xs-3">
            <div class="comm_label">
              {{ frame0.ruleName }}
            </div>
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_PAGE_ID')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <div class="comm_label">
              {{ frame0.pageId }}
            </div>
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_DTSVC_ID')"
              :vertical="false"
              required
            />
          </div>
          <div class="col-xs-3">
            <div class="comm_label">
              {{ frame0.dataServiceId }}
            </div>
          </div>
        </div>
      </div>
      <!-- 신규 -->
      <div
        v-if="ruleEditable"
        class="comm_view_wrap"
      >
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_WKFL_ID')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <div class="comm_label">
              {{ workflowId }}
            </div>
          </div>
          <div
            class="col-xs-1"
          >
            <sui-input-label
              :label="$t('MSG_TXT_MDLE')"
              :vertical="false"
            />
          </div>
          <div
            class="col-xs-3"
          >
            <sui-module-submodule-select
              ref="smComboFrame0"
              :pageId="pageId"
              :selectedMd="frame1.selectedCode.COD_MDLE"
              :selectedSmd="frame1.selectedCode.COD_SMDLE"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_RUL_NM')"
              :vertical="false"
              required
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              ref="ruleName"
              v-model="frame1.ruleName"
              max-length="100"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_PAGE_ID')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model="frame1.pageId"
              max-length="100"
              style="width:100%;"
              :readonly="true"
              :disabled="true"
            />
            <sui-button
              type="button"
              class="comm_btn_InputScr"
              @click="onClickPage"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_DTSVC_ID')"
              :vertical="false"
              required
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model="frame1.dataServiceId"
              max-length="100"
              style="width:100%;"
              :readonly="true"
              :disabled="true"
            />
            <sui-button
              type="button"
              class="comm_btn_InputScr"
              @click="onClickDataService"
            />
          </div>
        </div>
      </div>
      <div class="mrB30" />
      <div class="comm_view_wrap">
        <!-- <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              label="조건입력유형"
              :vertical="false"
            />
          </div>
          <div class="col-xs-11">
            <sui-radio
              v-model="radioStrValue"
              value="radio1"
            >
              자동
            </sui-radio>
            <sui-radio
              v-model="radioStrValue"
              value="radio1"
            >
              수동
            </sui-radio>
          </div>
        </div> -->
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_COND')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-11">
            <textarea
              v-model="ruleConditions"
              name="name"
              :readonly="true"
            />
          </div>
        </div>
        <div class="btn_wrap ta_r">
          <sui-button
            type="button"
            name="button"
            class="comm_btn_Reset"
            :disabled="!ruleEditable"
            @click="onClickCondConfig"
          >
            {{ $t('MSG_TXT_COND_SET') }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <div class="comm_title_wrap">
        <h4>{{ $t('MSG_TIT_TODO_INFO') }}</h4>
      </div>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TODO_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-11">
            <div class="comm_label">
              {{ frame2.nodeTodoName }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TODO_CLSF')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <div class="comm_label">
              {{ frame2.todoClassificationName }} / {{ frame2.todoDetailClassificationName }}
            </div>
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_DDLN_DT')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-radio
              v-model="frame2.deadlineDTYn"
              value="Y"
              :disabled="true"
            >
              Yes
            </sui-radio>
            <sui-radio
              v-model="frame2.deadlineDTYn"
              value="N"
              :disabled="true"
            >
              No
            </sui-radio>
            <div class="comp_spacing" />
            <div class="comm_label">
              D+{{ frame2.deadlineDTValue }}
            </div>
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TODO_CPLT_TYPE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-radio
              v-model="frame2.todoCompletionTypeCode"
              value="AL"
              :disabled="true"
            >
              All
            </sui-radio>
            <sui-radio
              v-model="frame2.todoCompletionTypeCode"
              value="AN"
              :disabled="true"
            >
              Any
            </sui-radio>
          </div>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="grid"
        :columns="gridColumns0"
        :dataset="'dsNodeTodoDetail'"
        :multiselect="false"
        :hideHeader="true"
      />
    </div>
    <div class="comm_btn_wrap mrR30">
      <sui-button
        type="button"
        class="comm_btn_border"
        @click="onClickCancel"
      >
        {{ $t('MSG_BTN_CANCEL') }}
      </sui-button>
      <sui-button
        type="button"
        class="comm_btn_solid"
        @click="onClickApply"
      >
        {{ $t('MSG_BTN_APPLY') }}
      </sui-button>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMR_00003_P05', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      default: null,
    },
    workflowId: {
      type: String,
      default: null,
    },
    setRelationRuleInfo: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      ruleConditionInfo: {
        handConditionList: [],
        autoConditionList: [],
      },
      ruleConditions: '',
      isPopupShow: false,
      ruleInsertType: '',
      frame0: {
        selectedCode: {
          COD_TYPE: {
            key: '',
            label: '',
          },
          COD_MDLE: {
            key: '',
            label: '',
          },
          COD_SMDLE: {
            key: '',
            label: '',
          },
        },
        ruleUid: '',
        ruleName: '',
        ruleUseYn: '',
        ruleExplanationContent: '',
        dataServiceId: '',
        pageId: '',
        ruleConditionContent: '',
        nodeToDoUid: '',
        moduleName: '',
        subModuleName: '',
        relationNodeTypeName: '',
      },
      frame1: {
        selectedCode: {
          COD_TYPE: {
            key: '',
            label: '',
          },
          COD_MDLE: {
            key: '',
            label: '',
          },
          COD_SMDLE: {
            key: '',
            label: '',
          },
        },
        ruleUid: '',
        ruleName: '',
        ruleUseYn: '',
        ruleExplanationContent: '',
        dataServiceId: '',
        pageId: '',
        ruleConditionContent: '',
        nodeToDoUid: '',
        moduleName: '',
        subModuleName: '',
      },
      frame2: {
        nodeTodoUid: '',
        nodeTodoName: '',
        deadlineDTYn: '',
        deadlineDTValue: '',
        pageId: '',
        todoCompletionTypeCode: '',
        todoProcessParamValue: '',
        todoClassificationName: '',
        todoDetailClassificationName: '',
      },
      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_ORDER'),
        datafield: 'nodeTodoDetailOrder',
      }, {
        text: this.$t('MSG_TXT_MSG_RESO'),
        datafield: 'nodeTodoDetailTitleMultiLanguageId',
      }, {
        text: this.$t('MSG_TXT_DTL_TIT'),
        datafield: 'nodeTodoDetailTitle',
      }, {
        text: this.$t('MSG_TXT_PRMT_ID'),
        datafield: 'nodeTodoDetailContent',
      }],
    };
  },
  computed: {
    ruleEditable() {
      if (utils.isEqual(this.ruleInsertType, 'new')) {
        return true;
      }
      return false;
    },
    ruleName() {
      if (utils.isEqual(this.ruleInsertType, 'new')) {
        return this.frame1.ruleName;
      }
      if (utils.isEqual(this.ruleInsertType, 'none')) {
        return '';
      }
      return this.frame0.ruleName;
    },
  },
  watch: {
    // data 변경시 특정 함수를 호출 해야 하는 경우(async 등)
    ruleInsertType() {
      if (utils.isEqual(this.ruleInsertType, 'none')) {
        this.ruleInfoReset();
      }
    },
  },
  datasets: [{
    id: 'dsNodeTodoDetail',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { type: 'string', name: 'nodeTodoDetailUid', map: 'nodeTodoDetailUid' },
      { type: 'string', name: 'nodeTodoUid', map: 'nodeTodoUid' },
      { type: 'string', name: 'nodeTodoDetailTitleMultiLanguageId', map: 'nodeTodoDetailTitleMultiLanguageId' },
      { type: 'string', name: 'nodeTodoDetailTitle', map: 'nodeTodoDetailTitle' },
      { type: 'string', name: 'nodeTodoDetailContent', map: 'nodeTodoDetailContent' },
      { type: 'string', name: 'nodeTodoDetailOrder', map: 'nodeTodoDetailOrder' },
      { type: 'string', name: 'knoxId', map: 'knoxId' },
      { type: 'string', name: 'userName', map: 'userName' },
      { type: 'string', name: 'userGlobalName', map: 'userGlobalName' },
      { type: 'string', name: 'departmentName', map: 'departmentName' },
      { type: 'string', name: 'departmentEnglishName', map: 'departmentEnglishName' },
      { type: 'string', name: 'displayLanguageId', map: 'displayLanguageId' },
      { type: 'string', name: 'finalModificationDTM', map: 'finalModificationDTM' },
    ],
  }],
  mounted() {
    // 신규 pageId,dataserviceId workflowNodeId 기준으로 초기 값 셋팅
    this.frame1.pageId = this.setRelationRuleInfo.workflowNodeInfo.pageId;
    this.frame1.dataServiceId = this.setRelationRuleInfo.workflowNodeInfo.dataServiceId;
    this.frame1.selectedCode.COD_MDLE.key = this.setRelationRuleInfo.workflowNodeInfo.moduleCode;
    this.frame1.selectedCode.COD_SMDLE.key = this.setRelationRuleInfo.workflowNodeInfo.subModuleCode;

    // 룰 정보 셋팅
    if (!utils.isUndefined(this.setRelationRuleInfo.ruleUid)
    && !utils.isEmpty(this.setRelationRuleInfo.ruleUid)) {
      this.setRelationRule();
    } else {
      this.ruleInsertType = 'none';
    }
    // 노드 할일 정보 셋팅
    if (!utils.isUndefined(this.setRelationRuleInfo.relationNodeId)
    && !utils.isEmpty(this.setRelationRuleInfo.relationNodeId)) {
      this.setNodeTodoData();
      this.setNodeTodoDetailData();
    }
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    /**
     * 페이지 선택 팝업
     * */
    onClickPage() {
      utils.openLayerPopup('PGE_CMU_00004', this.onPagePopupCallback, {
        pageInitialData: {
          selectionmode: 'singlerow', /* 'checkbox' 등 */
        },
        size: 'lg',
      });
    },
    onPagePopupCallback(nodeData) {
      if (nodeData) {
        this.frame1.pageId = nodeData[0].pageId;
      }
    },
    /**
     * 데이터서비스 선택 팝업
     * */
    onClickDataService() {
      utils.openLayerPopup('PGE_CMU_00005', this.onDataServicePopupCallback, {
        pageInitialData: { selectionmode: 'singlerow' },
        size: 'xlg',
      });
    },
    onDataServicePopupCallback(nodeData) {
      if (nodeData) {
        this.frame1.dataServiceId = nodeData[0].dataServiceIdentification;
      }
    },
    /**
     * 룰 불러오기 팝업
     * */
    onClickRule() {
      utils.openLayerPopup('PGE_CMR_00009', this.ruleSelectCallback, {
        pageInitialData: {
          multiselect: false, /* 'checkbox' 등 */
        },
        size: 'lg',
      });
    },
    ruleSelectCallback(data) {
      if (!utils.isEmpty(data)) {
        this.ruleInsertType = 'exist';

        utils.forEach(this.frame0, (value, key) => {
          this.frame0[key] = data[0][key];
        });

        this.setRuleConditions();
      }
    },

    /**
     * rule 기존 data 존재 시 기존 rule data로 값 셋팅
     */
    setRelationRule() {
      this.ruleInsertType = 'exist';
      utils.forEach(this.frame0, (value, key) => {
        this.frame0[key] = this.setRelationRuleInfo[key];
      });

      this.setRuleConditions();
    },
    /**
     * 할일정보 시작
     */
    setNodeTodoData() {
      const queryParams = {
        nodeId: this.setRelationRuleInfo.relationNodeId,
      };

      http.request(this.pageId, 'DTS_CMR_00024', {
        query: queryParams,
      }).then(res => {
        if (res.data.length < 1) {
          this.setNodeTodoDataReset();
        } else {
          utils.forEach(this.frame2, (value, key) => {
            this.frame2[key] = res.data[0][key];
          });
        }
      });
    },
    setNodeTodoDetailData() {
      const queryParams = {
        nodeId: this.setRelationRuleInfo.relationNodeId,
      };

      http.request(this.pageId, 'DTS_CMR_00026', {
        query: queryParams,
      }).then(res => {
        utils.dateformatToClientInArray(res.data, ['finalModificationDTM']);
        this.dsNodeTodoDetail.submit();
        this.dsNodeTodoDetail.setRawData(res.data); // 데이터 셋에 데이터를 넣는 함수
      });
    },
    setNodeTodoDataReset() {
      utils.forEach(this.frame2, (value, key) => {
        this.frame2[key] = '';
      });
      // this.detailListSetting();
      this.dsNodeTodoDetail.submit();
      this.dsNodeTodoDetail.setRawData([]);
    },
    /**
     * 룰 조건설정 팝업
     */
    ruleInfoReset() {
      utils.forEach(this.frame0, (value, key) => {
        this.frame0[key] = '';
      });
    },
    /**
     * 룰 조건설정 팝업
     */
    onClickCondConfig() {
      utils.openLayerPopup('PGE_CMR_00008', this.onCondConfigPopupCallback, {
        pageInitialData: {
          ruleUid: this.frame1.ruleUid,
          ruleName: this.frame1.ruleNamee,
          ruleConditionInfo: this.ruleConditionInfo,
          dataServiceId: this.frame1.dataServiceId,
        },
        size: 'xlg',
      });
    },
    onCondConfigPopupCallback(node) {
      if (!utils.isEmpty(node)) {
        this.ruleConditionInfo = node;
      }
    },
    /**
     * 룰 조건 조회
     */
    setRuleConditions() {
      http.request(this.pageId, 'DTS_CMR_00015', {
        path: {
          'rule-uid': this.frame0.ruleUid,
        },
      }).then(res => {
        this.ruleConditions = res.data.ruleText;
      });
    },
    /**
     * 룰 신규 저장 이벤트
     */
    ruleSave() {
      const ruleConditionList = utils.concat(this.ruleConditionInfo.handConditionList,
        this.ruleConditionInfo.autoConditionList);
      const dataParams = {
        ruleUid: '',
        ruleName: this.frame1.ruleName,
        ruleTypeCode: 'WF',
        moduleCode: this.frame1.selectedCode.COD_MDLE.key,
        subModuleCode: this.frame1.selectedCode.COD_SMDLE.key,
        ruleExplanationContent: '',
        dataServiceId: this.frame1.dataServiceId,
        pageId: this.frame1.pageId,
        ruleConditionContent: '',
        ruleUseYn: 'Y',
        nodeToDoUid: '',
        ruleConditionInfo: {
          insertRuleConditionList: ruleConditionList,
        },
      };

      if (!this.ruleMasterValidationCheck()) return false;

      http.request(this.pageId, 'DTS_CMR_00006', {
        data: dataParams,
      }).then(res => {
        this.frame1.ruleUid = res.data.msg;
        this.returnParam();
      });
      return true;
    },
    ruleMasterValidationCheck() {
      if (utils.isEmpty(utils.trim(this.frame1.selectedCode.COD_MDLE.key))) {
        // 모듈을 선택하세요
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_MDLE')));
        return false;
      }
      if (utils.isEmpty(utils.trim(this.frame1.selectedCode.COD_SMDLE.key))) {
        // 서브모듈을 선택하세요
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_SMDLE')));
        return false;
      }
      if (utils.isEmpty(utils.trim(this.frame1.ruleName))) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_RUL_NM')),
          null,
          () => {
            this.$refs.ruleName.setFocus();
          });
        return false;
      }
      if (utils.isEmpty(utils.trim(this.frame1.dataServiceId))) {
        // 데이터서비스를 선택하세요
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_DTSVC')));
        return false;
      }

      return true;
    },
    /**
     * 팝업 이벤트
     */
    onClickCancel() {
      this.$emit('popupClose');
    },
    onClickApply() {
      if (utils.isEqual(this.ruleInsertType, 'new')) {
        this.ruleSave();
      } else {
        this.returnParam();
      }
    },
    returnParam() {
      const relationRuleInfo = {
        ruleUid: '',
        ruleName: '',
        dataServiceId: '',
        moduleName: '',
        subModuleName: '',
        pageId: '',
      };
      if (!utils.isEqual(this.ruleInsertType, 'none')) {
        const ruleInfo = utils.isEqual(this.ruleInsertType, 'new') ? this.frame1 : this.frame0;

        utils.forEach(relationRuleInfo, (value, key) => {
          relationRuleInfo[key] = ruleInfo[key];
        });
      }
      this.$emit('paramReturn', relationRuleInfo, 'relationRuleInfo');
      this.$emit('popupClose');
    },
  },
};
</script>
<style scoped>
</style>
